// this data is used to contruct analytics data layer
import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router, Scroll } from '@angular/router';
import { filter, pairwise, withLatestFrom } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScrollRestorationService {
  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller,
  ) {
    this.scrollRestoration();
  }

  scrollRestoration(): void {
    const scrollEventSource = this.router.events.pipe(
      filter((e: Event): e is Scroll => {
        return e instanceof Scroll;
      }),
    );

    const routeEventSource = this.router.events.pipe(
      filter((e: Event): e is NavigationEnd => {
        return e instanceof NavigationEnd;
      }),
      pairwise(),
    );

    scrollEventSource
      .pipe(withLatestFrom(routeEventSource))
      .subscribe(([e, [prevRoute, currentRoute]]) => {
        const prevPathname = prevRoute.url.split('?')[0];
        const currentPathname = currentRoute.url.split('?')[0];

        if (prevPathname === currentPathname) {
          // Do nothing here to keep the current scroll position
          // when changing query params only
          return;
        }

        if (e.position) {
          // backward navigation
          // restore the scroll position
          // without setTimeout the scroll postion isn't restored
          // I guess some events scroll to the top of the page
          // which happen after this call stack
          // schedule the scrollToPosition fn in the next macro task as a work around
          setTimeout(() => {
            if (e.position) {
              this.viewportScroller.scrollToPosition(e.position);
            }
          }, 0);
          return;
        }

        if (e.anchor) {
          // anchor navigation
          return this.viewportScroller.scrollToAnchor(e.anchor);
        }
        // forward navigation
        // scroll the top of the page
        // I have no idea chrone need setTimeout to make it work as expected :)
        setTimeout(() => {
          this.viewportScroller.scrollToPosition([0, 0]);
        }, 0);
      });
  }
}
